import React from "react";
import { SEO, DispatchesDetailsMain, AdminLayout } from "../../../components";

const DispatchesDetailsPage = () => {
  return (
    <>
      <SEO title="Dispatche-Details" />
      <AdminLayout>
        <DispatchesDetailsMain />
      </AdminLayout>
    </>
  );
};

export default DispatchesDetailsPage;
